export default {
  version: 'master',
  compilation: '258349'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1475
// module chunks = 22